<template>
    <div class="login-page flex">
        <div class="box grow scrollable align-vertical side-box box-right login1">
            <div class="align-vertical-middle wrapper text-center">
                <form class="form-box" @submit.prevent="login">
                    <img class="image-logo" src="../../../assets/images/avatar.jpg"
                         style=" border-radius: 50%; margin-bottom: 20px;width: 120px" alt="logo-left"/>
                    <float-label class="styled">
                        <input type="username" name="username"
                               :placeholder="$t('src.views.authentication.login.kullaniciAdi')" v-model="username">
                    </float-label>
                    <float-label v-if="!sifreUnuttum" class="styled animated fadeInRight">
                        <input type="password" name="password" :placeholder="$t('src.views.authentication.login.sifre')"
                               v-model="password">
                    </float-label>
                    <float-label v-if="sifreUnuttum" label="TC NO" class="styled">
                        <input v-mask="'###########'" :placeholder="$t('src.views.authentication.login.tcNo')"
                               v-model="tcNo">
                    </float-label>
                    <div v-if="!sifreUnuttum" class="flex">
                        <div class="box grow text-right animated fadeInRight">
                            <el-button type="text" v-on:click="sifreUnuttum = true">
                                {{$t('src.views.authentication.login.sifremiUnuttum')}}
                            </el-button>
                        </div>
                    </div>
                    <div class="flex text-center center pt-30 pb-10">
                        <el-button v-if="!sifreUnuttum" plain size="small" native-type="submit"
                                   class="login-btn pulse animated themed animated fadeInRight">
                            {{$t('src.views.authentication.login.login')}}
                        </el-button>
                        <el-button v-if="sifreUnuttum" plain size="small" @click="sifremiUnuttum"
                                   class="login-btn pulse animated themed animated fadeInRight">
                            {{$t('src.views.authentication.login.sifreYenile')}}
                        </el-button>
                    </div>
                    <div style="margin-top: 10px">
                        <el-button
                                v-if="sifreUnuttum" v-on:click="sifreUnuttum=false"
                                class="buttonPage left animated fadeInRight delay-1s"
                                style="float: left; cursor: pointer" icon="mdi mdi-chevron-double-left" type="text"
                                size="small">
                        </el-button>
                    </div>
                </form>
            </div>
        </div>
        <div id="loginImg" class="box grow scrollable align-vertical side-box box-left loginImg">
            <div class="align-vertical-middle wrapper text-center">
                <img class="image-logo" src="../../../assets/images/logo3.png" alt="logo-left"/>
                <h1 class="h-big">{{$t('src.firma')}}</h1>
                <p class="p-50">{{$t('src.aciklama')}}</p>
            </div>
        </div>
        <div class="box grow scrollable align-vertical side-box box-right login2">
            <div class="align-vertical-middle wrapper">
                <form class="form-box" @submit.prevent="login">
                    <img class="image-logo" src="../../../assets/images/avatar.jpg"
                         style=" border-radius: 50%; margin-bottom: 20px;width: 120px" alt="logo-left"/>
                    <float-label class="styled animated fadeInLeft">
                        {{$t('src.views.authentication.login.firma')}}
                        <el-select
                                v-on:change="firmaChange"
                                v-model="firmaKodu"
                                style="margin-top: 10px;width: 100%">
                            <el-option
                                    v-for="item in firmaList"
                                    :key="item.firmaKodu"
                                    :label="item.firmaAdi"
                                    :value="item.firmaKodu"></el-option>
                        </el-select>
                    </float-label>
                    <div v-if="!firmaSecim && butonVisible"
                         class="flex text-center center pt-30 pb-10 animated fadeInLeft">
                        <el-button plain size="small" v-on:click="firmaSelect"
                                   class="login-btn pulse animated themed">
                            {{$t('src.views.authentication.login.login2')}}
                        </el-button>
                    </div>
                    <div style="margin-top: 10px">
                        <el-button v-if="geriBtn"
                                   v-on:click="ileriBtn=true; firmaSecim=false; geriBtn=false; butonVisible=false"
                                   class="buttonPage left animated fadeInRight delay-1s"
                                   style="float: left; cursor: pointer" icon="mdi mdi-chevron-double-left" type="text"
                                   size="small">
                        </el-button>
                        <el-button v-if="ileriBtn" v-on:click="ileriBtn=false; firmaSecim=true; geriBtn=true"
                                   class="buttonPage right animated fadeInLeft delay-1s"
                                   style="float: right; cursor: pointer" icon="mdi mdi-chevron-double-right" type="text"
                                   size="small">
                        </el-button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>


<script>
    import yonetimService from '../../../WSProvider/YoneticiService'
    import i18n from '../../../i18n'
    import notification from '../../../notification'
    import JQuery from 'jquery';

    let $ = JQuery;

    let base64 = require('base64_js');
    var crypto = require('crypto');
    export default {
        name: 'Login',
        data() {
            return {
                sifreUnuttum: false,

                username: '',
                password: '',
                tcNo: '',
                firmaSecim: false,
                ileriBtn: false,
                geriBtn: false,
                butonVisible: true,
                response: {},
                firmaList: [],
                subeList: [],
                firmaKodu: '',
                firmaAdi: '',
                subeKodu: '',
                subeAdi: ''

            }
        },
        methods: {
            login() {
                let self = this;
                yonetimService.girisYap(this.username, this.password).then((response) => {
                    if (response.status === 200) {
                        if (response.data.firma) {
                            $(".loginImg").css("left", "0");
                            this.firmaList = response.data.firma;
                            this.firmaKodu = this.firmaList[0].firmaKodu;
                            this.firmaAdi = this.firmaList[0].firmaAdi;
                            this.response = response.data;
                            $('.login2').show();
                            if ($(window).width() < 768) {
                                $(".login1").addClass('yukariCek');
                            }
                        } else if (!response.data.firma) {
                            if (response.data && response.data.yonetimId) {
                                var userData5B = base64.encode(encodeURI(JSON.stringify(response.data)))
                                localStorage.setItem("userData5B", userData5B);
                                self.$store.commit('setLogin');
                                self.$router.push('/');
                                this.$store.commit('changeNavVisible', true);
                            }
                        }
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            firmaChange() {
                this.butonVisible = true;
                this.ileriBtn = false;
                this.firmaList.forEach(function (e) {
                    if (this.firmaKodu && e.firmaKodu === this.firmaKodu) {
                        this.firmaAdi = e.firmaAdi;
                    }
                })
            },
            firmaSelect() {
                this.response.firmaKodu = this.firmaKodu;
                // console.log(this.response);
                var userData5B = base64.encode(encodeURI(JSON.stringify(this.response)))
                localStorage.setItem("userData5B", userData5B);
                this.$store.commit('setLogin');
                this.$router.push('/');
                this.$store.commit('changeNavVisible', true);

            },
            sifremiUnuttum() {
                yonetimService.sifremiUnuttum(this.username, this.tcNo).then((response) => {
                    if (response.status === 200) {
                        notification.Status('success', this, 'Yeni Şifreniz E-Posta Adresinize gönderilmiştir.');
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            }
        }
    }
</script>

<style lang="scss">
    @import '../../../assets/scss/_variables';

    .layout-container .container .main {
        background: #fff;
    }


    .login-page {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 0 !important;

        .side-box {
            .wrapper {
                width: 100%;
                box-sizing: border-box;
                padding: 20px;
            }
        }

        .box-left {
            background-image: url('../../../assets/images/login2.jpg');
            background-size: cover;
            background-position: 50% 50%;

            .wrapper {
                .image-logo {
                    width: 90%;
                    max-width: 100px;
                    margin-top: 20px;
                }

            }
        }

        .box-right {
            background: white;
            color: var(--background-color);
        }

        .form-box {
            width: 100%;
            max-width: 340px;
            padding: 30px;
            box-sizing: border-box;
            margin: 20px auto;
            //background: transparent;

            a {
                font-size: 14px;
                color: var(--color-accent);
                text-decoration: none;
                font-weight: 500;
            }

            .image-logo {
                width: 80px;
                margin: 0px auto;
                margin-bottom: 70px;
                display: block;
            }

            .login-btn {
                background: rgba(var(--color-accent-rgb), .2);
                color: var(--text-color);
                border-color: var(--text-color);
                border-width: 2px;
                font-weight: bold;
                border-radius: 0;

                &:hover {
                    background: rgba(var(--color-accent-rgb), 1);
                    border-color: var(--text-color);
                    color: var(--text-color);
                }
            }
        }
    }

    @media (max-width: 1200px) {
        .login-page {
            .box-left {
                .wrapper {
                    .h-big {
                        font-size: 50px;
                    }
                }
            }
        }
    }

    @media (max-width: 900px) {
        .login-page {
            .box-left {
                .wrapper {
                    .h-big {
                        font-size: 30px;
                    }
                }
            }
        }
    }

    @media (max-width: 768px) {
        .login-page {
            display: block;
            overflow: auto;

            .side-box {
                display: block;
            }
        }
        .loginImg {
            position: absolute;
            z-index: 100;
            height: 65%;
            transition: all 0.8s ease;
        }
        .login1 {
            transition: 1s;
            z-index: 1;
            display: block !important;
            position: relative;
            transform: translateY(0);
        }
        .login2{
            position: absolute;
            width: 100%;
            top: 0;
            height: 500px;
        }
        .yukariCek{
            transform: translateY(-100%);
        }


    }
    @media (min-width: 768px) {
        .login1 {
            position: relative;
            z-index: 90;
            right: 0;
        }

        .login2 {
            position: relative;
            z-index: 90;
            left: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            padding-left: 30%;
        }

        .loginImg {
            position: absolute;
            left: 35%;
            height: 100%;
            width: 65%;
            z-index: 100;
            transition: all 0.8s ease;
        }
    }
</style>



